import "./LandingPageButton.css";

const LandingPageButton = () => {
  return (
    <a
      className="flex j-c--center a-i--center landing-page__button"
      href="#offer"
    >
      oferta
    </a>
  );
};
export default LandingPageButton;
